import { useEffect, useState, useRef } from 'react';
import { object } from 'prop-types';
import cn from 'classnames';

import DropDown from '../../../elements/DropDown/DropDown';
import { ReactComponent as ArrowPink } from '../../../styles/icon/header/arrow-pink.svg';
import { navlist } from '../../../constants/navis';
import NavigationIcon from './NavigationIcon';
import strings from '../../../lang/lang';
import { getPageNameByUrl } from '../docsHelper';
import GuideNavigation from '../GuideNavigation/GuideNavigation';
import SdkNavigation from '../SdkNavigation/SdkNavigation';
// import Guides from '../Guides';
// import Sdks from '../Sdks';
import Apis from '../Apis';
import { NavigationMenu } from '../../../components';

import mobileNavigation from './MobileDocsNavigation.module.scss';

MobileDocsNavigation.propTypes = {
  location: object,
};

function MobileDocsNavigation(props) {
  const menuRef = useRef(null);
  const [activePageName, setPageName] = useState('');
  const [activeSubPageName, setSubPageName] = useState('subMenu');
  const [isOpenMenu, toggleMainMenu] = useState(false);
  const [isOpenSubMenu, toggleSubMenu] = useState(false);
  const [isVisibleSubMenu, preventClosingMenu] = useState(false);

  const { location } = props;
  const pathname = location.pathname;

  useEffect(() => {
    let lastScrollPosition = 0;
    const header = document.getElementById('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const menuHeight = menuRef.current.offsetHeight;

    const handleScroll = () => {
      const offset = window.scrollY || document.documentElement.scrollTop;
      if (offset > headerHeight) { //
        if (offset > lastScrollPosition){ //scroll down
          if (offset > (headerHeight + menuHeight)) {
            menuRef.current.classList.add('hide');
            menuRef.current.classList.remove('show');
          }
        } else { //scroll up
          menuRef.current.classList.remove('hide');
          menuRef.current.classList.add('show');
        }
      } else {
        menuRef.current.classList.remove('hide');
        menuRef.current.classList.remove('show');
      }
      lastScrollPosition = offset <= 0 ? 0 : offset;
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const page = navlist.find(c => pathname.indexOf(c.activeInPathname) > -1) || {};
    setPageName(strings.header.text[page.name])
  }, [pathname]);

  useEffect(() => {
    if (!isVisibleSubMenu) {
      toggleSubMenu(false);
    }
  }, [isVisibleSubMenu]);

  useEffect(() => {
    const subPage = getPageNameByUrl(pathname);
    toggleMainMenu(false);
    preventClosingMenu(false);
    toggleSubMenu(false);
    setSubPageName(subPage);
  }, [pathname]);

  useEffect(() => {
    if (isOpenMenu || isOpenSubMenu) {
      document.body.classList.add('isHidden');
    } else {
      document.body.classList.remove('isHidden');
    }
  }, [isOpenMenu, isOpenSubMenu]);

  const isGuides = pathname.indexOf('/guides') !== -1;
  const isApis = pathname.indexOf('/apis') !== -1;
  const isSdks = pathname.indexOf('/sdks') !== -1;

  return (
    <div
      className={cn(mobileNavigation.panel, 'mobile-navigation-panel')}
      ref={menuRef}
    >
      <div
        className={cn(mobileNavigation.menu, {
          [mobileNavigation['menu--active']]: isOpenMenu
        })}
      >
        <DropDown
          trigger={(isOpened) => (
            <button
              className={cn(mobileNavigation.mobile_trigger, {
                [mobileNavigation['mobile_trigger--active']]: isOpenMenu
              })}
              onClick={() => {
                toggleMainMenu(!isOpenMenu);
                toggleSubMenu(false);
              }}
            >
              <NavigationIcon icon={activePageName} />
              <span className={mobileNavigation.mobile_trigger__name}>{activePageName}</span>
              <ArrowPink />
            </button>
          )}
          className={mobileNavigation.mobile_menu}
          classNameBody={mobileNavigation.menu__body}
          handleClose={() => {}}
          isOpened={isOpenMenu}
        >
          <div className={mobileNavigation.main_dropdown__links}>
            <NavigationMenu
              className="mobile"
            />
          </div>
        </DropDown>
      </div>
      <div className={mobileNavigation.menu}>
        <DropDown
          trigger={(isOpened) => (
            <button
              className={cn(mobileNavigation.mobile_trigger, {
                [mobileNavigation['mobile_trigger--active']]: isOpenSubMenu,
              })}
              onClick={() => {
                toggleMainMenu(false);
                toggleSubMenu(!isOpenSubMenu);
              }}
            >
              <span>{activeSubPageName}</span>
              <ArrowPink />
            </button>
          )}
          className={mobileNavigation.menu}
          classNameBody={mobileNavigation.menu__body}
          handleClose={() => {}}
          isOpened={isOpenSubMenu}
        >
          <div
            className={mobileNavigation.links}
          >
            {isGuides && (
              <div id="menu-section-guides">
                <GuideNavigation
                  location={location}
                  preventClosingMenu={() => preventClosingMenu(true)}
                />
              </div>
            )}
            {isApis && (
              <div id="menu-section-apis">
                <Apis
                  location={location}
                  callback={() => preventClosingMenu(true)}
                />
              </div>
            )}
            {isSdks && (
              <div id="menu-section-sdks">
                <SdkNavigation
                  location={location}
                  preventClosingMenu={() => preventClosingMenu(true)}
                />
              </div>
            )}
          </div>
        </DropDown>
      </div>
    </div>
  );
}

export default MobileDocsNavigation;
